import { useZocksAuth } from '../../../components/ScopedBlock/hooks'
import { useMcpAppsAccess } from '../../../common/useMcpAppsAccess'

interface UseMcpPromoEligibilityParams {
  skip?: boolean
}

export const useMcpPromoEligibility = ({ skip = false }: UseMcpPromoEligibilityParams = {}) => {
  const { hasScope } = useZocksAuth()
  const { mcpAppsAvailable, mcpAppsEnabled, hasMcpConnection, oauth2Enabled, isFetching, probes } = useMcpAppsAccess({ skip })

  const canManageOAuth2Apps = hasScope('**', 'oauth2_app:update', ['oauth2_app:admin'])

  return {
    mcpAppsAvailable,
    mcpAppsEnabled,
    hasMcpConnection,
    canManageOAuth2Apps,
    oauth2Enabled,
    isFetching,
    probes,
  }
}
